module.exports = __webpack_public_path__ + "img/congratulations.8e96ff7a.svg";